export enum SIGNATURE_STATUS {
	None = 0,
	AgencySigned = 1,
	ClientSigned = 2,
	TempWorkerSigned = 4,
	AgencyTimeStamp = 8,
}
